import type { ReactNode, SVGProps } from 'react';

export interface StakkoIconProps extends SVGProps<SVGSVGElement> {
  size?: number;
}

function Icon({ size = 20, children, ...props }: StakkoIconProps & { children: ReactNode }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      {children}
    </svg>
  );
}

export function UserIcon(props: StakkoIconProps) {
  return (
    <Icon {...props}>
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21c0-4 3.6-6 8-6s8 2 8 6" />
    </Icon>
  );
}

export function GridIcon(props: StakkoIconProps) {
  return (
    <Icon {...props}>
      <rect x="3" y="3" width="7" height="7" rx="2" />
      <rect x="14" y="3" width="7" height="7" rx="2" />
      <rect x="3" y="14" width="7" height="7" rx="2" />
      <rect x="14" y="14" width="7" height="7" rx="2" />
    </Icon>
  );
}

export function CoinsIcon(props: StakkoIconProps) {
  return (
    <Icon {...props}>
      <ellipse cx="12" cy="6" rx="8" ry="3" />
      <path d="M4 6v6c0 1.7 3.6 3 8 3s8-1.3 8-3V6" />
      <path d="M4 12v6c0 1.7 3.6 3 8 3s8-1.3 8-3v-6" />
    </Icon>
  );
}

export function UsersIcon(props: StakkoIconProps) {
  return (
    <Icon {...props}>
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </Icon>
  );
}

export function BellIcon(props: StakkoIconProps) {
  return (
    <Icon {...props}>
      <path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9" />
      <path d="M10 21h4" />
    </Icon>
  );
}

export function SettingsIcon(props: StakkoIconProps) {
  return (
    <Icon {...props}>
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.7 1.7 0 0 0 .34 1.87l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.7 1.7 0 0 0-1.87-.34 1.7 1.7 0 0 0-1 1.55V21a2 2 0 1 1-4 0v-.09A1.7 1.7 0 0 0 9 19.36a1.7 1.7 0 0 0-1.87.34l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.7 1.7 0 0 0 4.64 15a1.7 1.7 0 0 0-1.55-1H3a2 2 0 1 1 0-4h.09A1.7 1.7 0 0 0 4.64 9a1.7 1.7 0 0 0-.34-1.87l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.7 1.7 0 0 0 9 4.64h.08A1.7 1.7 0 0 0 10 3.09V3a2 2 0 1 1 4 0v.09a1.7 1.7 0 0 0 1 1.55 1.7 1.7 0 0 0 1.87-.34l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.7 1.7 0 0 0 19.36 9v.08a1.7 1.7 0 0 0 1.55 1H21a2 2 0 1 1 0 4h-.09a1.7 1.7 0 0 0-1.51 1Z" />
    </Icon>
  );
}

export function PlusIcon(props: StakkoIconProps) {
  return (
    <Icon {...props}>
      <path d="M12 5v14M5 12h14" />
    </Icon>
  );
}

export function XIcon(props: StakkoIconProps) {
  return (
    <Icon {...props}>
      <path d="M18 6 6 18M6 6l12 12" />
    </Icon>
  );
}

export function CheckIcon(props: StakkoIconProps) {
  return (
    <Icon {...props}>
      <path d="m20 6-11 11-5-5" />
    </Icon>
  );
}

export function LogOutIcon(props: StakkoIconProps) {
  return (
    <Icon {...props}>
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <path d="m16 17 5-5-5-5" />
      <path d="M21 12H9" />
    </Icon>
  );
}

export function SunIcon(props: StakkoIconProps) {
  return (
    <Icon {...props}>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2M4.93 4.93l1.42 1.42M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.42-1.42M17.66 6.34l1.41-1.41" />
    </Icon>
  );
}

export function MoonIcon(props: StakkoIconProps) {
  return (
    <Icon {...props}>
      <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8Z" />
    </Icon>
  );
}

export function ChevronRightIcon(props: StakkoIconProps) {
  return (
    <Icon {...props}>
      <path d="m9 18 6-6-6-6" />
    </Icon>
  );
}

export function ArrowUpRightIcon(props: StakkoIconProps) {
  return (
    <Icon {...props}>
      <path d="M7 17 17 7M7 7h10v10" />
    </Icon>
  );
}

export function SparklesIcon(props: StakkoIconProps) {
  return (
    <Icon {...props}>
      <path d="m12 3 1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9L12 3Z" />
      <path d="M19 3v4M21 5h-4" />
    </Icon>
  );
}

export function CalendarIcon(props: StakkoIconProps) {
  return (
    <Icon {...props}>
      <rect x="3" y="4" width="18" height="17" rx="3" />
      <path d="M16 2v4M8 2v4M3 9h18" />
      <path d="M8 13h2M14 13h2M8 17h2M14 17h2" />
    </Icon>
  );
}

export function BrainIcon(props: StakkoIconProps) {
  return (
    <Icon {...props}>
      <path d="M9.5 3A3.5 3.5 0 0 0 6 6.5v.7A3.5 3.5 0 0 0 4 10.5c0 1.2.6 2.3 1.5 3A3.5 3.5 0 0 0 9 19.5V21" />
      <path d="M14.5 3A3.5 3.5 0 0 1 18 6.5v.7a3.5 3.5 0 0 1 2 3.3c0 1.2-.6 2.3-1.5 3a3.5 3.5 0 0 1-3.5 3V21" />
      <path d="M12 3v18M9 8h3M12 13h3" />
    </Icon>
  );
}

export function DumbbellIcon(props: StakkoIconProps) {
  return (
    <Icon {...props}>
      <path d="M6 7v10M18 7v10M3 12h18M9 5v14M15 5v14" />
    </Icon>
  );
}

export function TicketIcon(props: StakkoIconProps) {
  return (
    <Icon {...props}>
      <path d="M3 9a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v1a2 2 0 0 0 0 4v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-1a2 2 0 0 0 0-4V9Z" />
      <path d="M13 7v2M13 11v2M13 15v2" />
    </Icon>
  );
}

export function WalletIcon(props: StakkoIconProps) {
  return (
    <Icon {...props}>
      <rect x="3" y="6" width="18" height="14" rx="3" />
      <path d="M3 10h18M16 15h2" />
      <path d="M7 6V4a1 1 0 0 1 1-1h9" />
    </Icon>
  );
}

export function LayoutIcon(props: StakkoIconProps) {
  return (
    <Icon {...props}>
      <rect x="3" y="3" width="18" height="18" rx="3" />
      <path d="M9 3v18M9 9h12" />
    </Icon>
  );
}

export function DiceIcon(props: StakkoIconProps) {
  return (
    <Icon {...props}>
      <rect x="3" y="3" width="18" height="18" rx="4" />
      <circle cx="8.5" cy="8.5" r=".8" fill="currentColor" />
      <circle cx="15.5" cy="8.5" r=".8" fill="currentColor" />
      <circle cx="12" cy="12" r=".8" fill="currentColor" />
      <circle cx="8.5" cy="15.5" r=".8" fill="currentColor" />
      <circle cx="15.5" cy="15.5" r=".8" fill="currentColor" />
    </Icon>
  );
}

export function HelpIcon(props: StakkoIconProps) {
  return (
    <Icon {...props}>
      <circle cx="12" cy="12" r="9" />
      <path d="M9.5 9a2.5 2.5 0 1 1 3.5 2.3c-.6.3-1 .9-1 1.6v.3" />
      <path d="M12 17h.01" />
    </Icon>
  );
}

export function ShieldIcon(props: StakkoIconProps) {
  return (
    <Icon {...props}>
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z" />
      <path d="m9 12 2 2 4-4" />
    </Icon>
  );
}

export function GiftIcon(props: StakkoIconProps) {
  return (
    <Icon {...props}>
      <rect x="3" y="8" width="18" height="13" rx="2" />
      <path d="M3 12h18M12 8v13" />
      <path d="M12 8a3 3 0 1 0-3-3c0 1.7 1.3 3 3 3ZM12 8a3 3 0 1 1 3-3c0 1.7-1.3 3-3 3Z" />
    </Icon>
  );
}

export function SearchIcon(props: StakkoIconProps) {
  return (
    <Icon {...props}>
      <circle cx="11" cy="11" r="7" />
      <path d="m20 20-3.5-3.5" />
    </Icon>
  );
}

export function SendIcon(props: StakkoIconProps) {
  return (
    <Icon {...props}>
      <path d="m22 2-7 20-4-9-9-4Z" />
      <path d="M22 2 11 13" />
    </Icon>
  );
}

export function TrashIcon(props: StakkoIconProps) {
  return (
    <Icon {...props}>
      <path d="M3 6h18M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2" />
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" />
      <path d="M10 11v6M14 11v6" />
    </Icon>
  );
}

export function StakkoMarkIcon(props: StakkoIconProps) {
  return (
    <Icon {...props}>
      <path d="M4 4h4l4 16 4-16h4" />
    </Icon>
  );
}
